export const enum NavArea {
    LANDING = 1,
    BUY,
    RENT,
    MY_AREA,
}
